<template>
    <section class="margin-both-xl container" :class="classes">
        <div class="inner">
            <div class="content-inner padding-lg jost">
                <h2 class="module-title jost--35 font--700"><span>{{data.title}}</span></h2>
                <div class="description jost--25 font--500" v-if="data.description" v-html="data.description" />
                <ul class="links" v-if="data.links && data.links.length">
                    <li class="link-h" v-for="({link, color}, k) in data.links" :key="k">
                        <ColorLink :key="k" :link="link" class="font--600 text-uppercase" color="green" :icon="false" :outlined="false"/>
                    </li>
                </ul>
            </div>
            <div class="imager" v-if="data.image">
                <WpImage
                    :image="data.image"
                    size="large"
                    class="side-image"
                    cover
                    background
                />
            </div>
        </div>
    </section>
</template>

<script>
import WpImage from '@/components/elements/WpImage';
import ColorLink from '@/components/elements/ColorLink'

export default {
    name: 'presentation-links',
    props: ['data'],
    computed:{
        classes(){
            let classes = []
            if(this.data.image_side) classes.push('side-'+this.data.image_side)
            if(this.data.image) classes.push('has-image') 
            else classes.push('no-image')

            return classes.join(' ')
        }
    },
    components:{
        WpImage,
        ColorLink
    },
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.module-presentation_links{
    .module-title{
        margin-top: 0;
        margin-bottom: 25px;
        z-index: 5;
    }
    .links{
        margin-top: 35px;
        margin-bottom: 0;
        padding: 0;
        margin-left: -12px;
        margin-right: -12px;
        margin-bottom: -12px;
        li{
            list-style: none;
            display: inline-block;
            margin-left: 12px;
            margin-right: 12px;
            margin-bottom: 12px;
        }
        @include mquery($phone){
            margin-left: -6px;
            margin-right: -6px;
            margin-bottom: -6px;
            margin-top: 20px;
            li{
                margin-bottom: 6px;
                margin-left: 6px;
                margin-right: 6px;
            }
        }
    }
    .inner{
        background-color: $dark;
        border-radius: $blocksRadius;
        .content-inner{
            color: #fff;
            @include mquery($phone){
                max-width: 100%;
            }
        }
    }
    &.no-image{
        .content-inner{
            text-align: center;
        }
        .module-title{
            &:after, &:before{
                display: inline-block;
            }
        }  
    }
    &.has-image{
        &.side-right{
            .content-inner{
                @include mquery($phone){
                    order: 2;
                }
            }
            .wp-image-vue.background .image{
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                @include mquery($phone){
                    border-bottom-right-radius: 0;
                    border-top-left-radius: $blocksRadius;
                }
            }
        }
        &.side-left{
            .content-inner{
                order: 2;
            }
            .wp-image-vue.background .image{
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                @include mquery($phone){
                    border-bottom-left-radius: 0;
                    border-top-right-radius: $blocksRadius;
                }
            }
        }
        .wp-image-vue{
            height: 100%;
            
        }
        .wp-image-vue.background .image{
            padding-bottom: 45.25%;
            min-height: 100%;
            @include mquery($phone){
                min-height: 200px;
            }
        }
        .inner{
            display: flex;
            @include mquery($phone){
                flex-direction: column;
            }
            .content-inner{
                max-width: 60%;
                width: 100%;
                align-self: center;
                position: relative;
                z-index: 10;
                @include mquery($phone){
                    max-width: 100%;
                }
            }
            .imager{
                max-width: 40%;
                width: 100%;
                @include mquery($phone){
                    max-width: 100%;
                }

            }
        }
    }
}
</style>